<template>
  <div class="TheBanner">
    <UIContainer class="TheBanner__container" :withPadding="false">
      <div class="TheBanner__left">
        <img
          class="TheBanner__left-image"
          :src="PercentageIcon"
          alt="Percentage image"
        />

        <div class="TheBanner__left-content">
          <h1 class="TheBanner__left-title">
            Get audit-ready for year-end and save 15% on your first year.
          </h1>
          <p class="TheBanner__left-description">
            Offer valid for all new agreements signed before December 31st.
          </p>
        </div>
      </div>

      <div class="TheBanner__right">
        <UIButton
          class="TheNavbar__cta-action"
          size="lg"
          theme="light"
          buttonStyle="outlined"
        >
          Book a demo
        </UIButton>
        <UIButton size="lg">Get started</UIButton>
      </div>
    </UIContainer>
    <UIButtonIcon
      class="TheBanner__right-close"
      icon="close"
      @click="$emit('close')"
    />
  </div>
</template>

<script setup lang="ts">
import UIButton from '../../buttons/UIButton.vue'
import UIButtonIcon from '../../buttons/UIButtonIcon.vue'
import UIContainer from '../../containers/UIContainer/UIContainer.vue'
import PercentageIcon from './assets/percentage.png'

defineEmits(['close'])
</script>

<style lang="scss" scoped>
.TheBanner {
  background: $color-ui-brand-700;
  width: 100%;
  padding: 0.75rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid $color-ui-brand-600;

  @include md {
    max-height: 74px;
  }
  .TheBanner__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    gap: 1rem;

    @include md {
      flex-direction: row;
    }
  }

  .TheBanner__left {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .TheBanner__left-title {
    @include font-size-12px();
    color: $color-white;
    font-weight: 600;
    margin-bottom: 0.125rem;

    @include md {
      @include font-size-16px();
    }
  }

  .TheBanner__left-description {
    @include font-size-12px();
    color: $color-ui-brand-200;
    font-weight: 400;

    @include md {
      @include font-size-16px();
    }
  }

  .TheBanner__right {
    display: flex;
    gap: 0.75rem;
  }

  .TheBanner__right-close {
    --icon-size: 1rem;
    --icon-color: #b3cfc9;

    margin-right: 1rem;
  }
}
</style>
